<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card shadow border-0 rounded-4">
        <div class="card-body p-4">
          <div class="text-center mx-auto py-3">
            <a class="navbar-brand" routerLink="/"><img [src]="logoUrl" [alt]="logoAlt" height="60" /></a>
          </div>

          <h3 class="mb-3 text-center">Reset your password</h3>
          <p class="text-center text-muted mb-4">
            Enter the email associated with your account and we'll send you a link to reset your password.
          </p>

          <ng-container *ngIf="resetSuccess(); else resetFormTemplate">
            <div class="alert alert-success d-flex align-items-start" role="alert">
              <i class="bi bi-check-circle-fill me-2"></i>
              <div>
                <h6 class="alert-heading mb-1">Check your inbox</h6>
                <p class="mb-2">
                  We sent a password reset link to <strong>{{ emailPreview() || 'your email' }}</strong>.
                  If you don't see it, check your spam folder.
                </p>
                <button type="button" class="btn btn-outline-success btn-sm" (click)="resetFormState()">Send another email</button>
              </div>
            </div>
          </ng-container>

          <ng-template #resetFormTemplate>
            <form (ngSubmit)="onReset()" [formGroup]="resetForm">
              <div class="mb-3">
                <label for="email" class="form-label">Email address</label>
                <input type="email" formControlName="email" class="form-control" id="email" placeholder="you@boatmail.com">
              </div>
              <div *ngIf="errorMessage()" class="alert alert-danger d-flex align-items-center" role="alert">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                <span>{{ errorMessage() }}</span>
              </div>
              <button type="submit" class="btn btn-primary w-100" [disabled]="resetForm.invalid || isSubmitting()">
                <span *ngIf="!isSubmitting(); else submitting">Send reset link</span>
              </button>
              <ng-template #submitting>
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Sending...
              </ng-template>
            </form>
          </ng-template>

          <div class="text-center mt-4">
            <small>Remembered your password? <a routerLink="/login" [queryParams]="loginLinkQueryParams">Back to sign in</a></small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
